export {
  $createWorkflowStaticContentNode,
  $isWorkflowStaticContentNode,
  WorkflowStaticContentNode
} from './WorkflowStaticContentNode';
export type { SerializedWorkflowStaticContentNode } from './WorkflowStaticContentNode';
